module.exports = __webpack_public_path__ + "media/images/categories/extroversion-625697f504c81118d66517eeaa44156c.png";